const IndemnityCardItem = ({ item, index }) => {
	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item.id || "1"}</strong>
			</td>
			<td>{item?.name || "Muhammed"}</td>
			<td>{item?.job_title || "Software Engineer"}</td>
			<td>{item?.department?.name || "IT"}</td>
			<td>{item?.start_date?.split("T")[0] || "N/A"}</td>
			<td>{item?.civil_id || "N/A"}</td>
			<td>{item?.accrued_leave || 0}</td>
			<td>{item?.salary || 0}</td>
			<td>{item?.dailyIndemnity || 0}</td>
			<td>{item?.exceedingYearsIndemnity || 0}</td>
			<td>{item?.first5YearsIndemnity || 0}</td>
			<td>{item?.monthlyIndemnity || 0}</td>
			<td>{item?.paidLeaveBalanceAmount || 0}</td>
			<td>{item?.totalIndemnity || 0}</td>
		</tr>
	);
};
export default IndemnityCardItem;
